import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroImg2 from "../components/HeroImg2";
import Work from "../components/Work";

import "../components/ProjectStyles.css";  

const Project = () => {
  return (
    <div>
      <Navbar />
      
      {/* Full-screen Video Section */}
      <div className="video-container">
        <video
          className="project-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/videos/projects.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      
      <HeroImg2 heading="PROJECTS." text="Some of my works" />
      <Work />
      <Footer />
    </div>
  );
};

export default Project;
